import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '定时功能',
    type: 'SF_3',
}
